import { RefObject, useLayoutEffect, useRef } from 'react';
import { useZoomStore } from '../store/zoom.store';

export const useScrollPreservation = (scrollRef: RefObject<HTMLElement | null>) => {
  const { pxPerMinute } = useZoomStore(['pxPerMinute']);

  const previousPxPerMinuteRef = useRef(pxPerMinute);
  const capturedScrollTopRef = useRef<number | null>(null);

  // Capture scrollTop synchronously before React commits the layout update
  if (previousPxPerMinuteRef.current !== pxPerMinute && scrollRef.current) {
    capturedScrollTopRef.current = scrollRef.current.scrollTop;
  }

  useLayoutEffect(() => {
    const container = scrollRef.current;
    const previousPxPerMinute = previousPxPerMinuteRef.current;

    if (!container || previousPxPerMinute === pxPerMinute) {
      previousPxPerMinuteRef.current = pxPerMinute;
      return;
    }

    const scrollTop = capturedScrollTopRef.current ?? container.scrollTop;
    const zoomRatio = pxPerMinute / previousPxPerMinute;
    container.scrollTop = scrollTop * zoomRatio;

    previousPxPerMinuteRef.current = pxPerMinute;
    capturedScrollTopRef.current = null;
  }, [pxPerMinute, scrollRef]);
};
